import React from "react";
import moment from "moment";
import "moment/locale/bg";
import { useInput } from "react-admin";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
const customDatePickerDefault = {
  "& .MuiOutlinedInput-notchedOutline": {
    height: "44px",
    margin: "3px 0px 3px 0px",
    top: "-2px",
  },
  "& .MuiOutlinedInput-root": {
    fontSize: "14px",
  },
  "& .MuiFormLabel-root": {
    top: "1px",
  },
  minWidth: "18rem",
  margin: ".5em 0",
};

const CustomDateInput = props => {
  const { onChange, onBlur, ...rest } = props;

  const {
    field,
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
    isRequired,
  } = useInput({
    onChange,
    onBlur,
    ...props,
  });
  const handleChange = date => {
    field.onChange(`${date?.format("YYYY-MM-DD")}${"T00:00:00.0000000Z"}`);
  };

  const value = field?.value ? moment(field.value) : null;

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      dateLibInstance={moment.utc}
      adapterLocale="bg"
    >
      <DatePicker
        {...field}
        label={props.label}
        format="DD-MM-YYYY"
        value={value}
        sx={customDatePickerDefault}
        onChange={handleChange}
        error={(isTouched || isSubmitted) && invalid}
        helperText={(isTouched || isSubmitted) && invalid ? error : ""}
        required={isRequired}
        slotProps={{
          actionBar: {
            actions: ["clear"],
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default CustomDateInput;
